import { render, staticRenderFns } from "./RetailerOrder.vue?vue&type=template&id=57e96426&lang=pug"
import script from "./RetailerOrder.vue?vue&type=script&lang=js"
export * from "./RetailerOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports